import { ProductDto } from '@features/products/interfaces/productInterface';
import { PageLimitFilter } from '@typings';
import qs from 'qs';

import { baseClient } from 'src/app/baseClient';
import { PaginatedResponse } from 'src/app/typings/PaginatedResponse';

import {
  Offer,
  OfferPayload,
  OfferProperties,
  OffersByProduct,
} from '../interfaces/offersInterface';

async function getProducts(): Promise<ProductDto[]> {
  const endpoint = `/products/product-sell-group`;
  return (await baseClient.get(endpoint)).data;
}

async function getOffers(productId: string): Promise<OffersByProduct> {
  const endpoint = `/products/product-sell-group/${productId}`;
  return (await baseClient.get(endpoint)).data;
}

async function getOfferProperties(): Promise<OfferProperties> {
  const endpoint = `/products/v2/properties`;
  const { data } = await baseClient.get(endpoint);
  return data;
}

async function getPaginatedOffers(
  productId: string,
  pagination?: PageLimitFilter
): Promise<PaginatedResponse<Offer>> {
  const endpoint = `/products/v2/${productId}/offers`;
  const { data } = await baseClient.get<PaginatedResponse<Offer>>(endpoint, {
    params: {
      page: pagination?.page,
      limit: pagination?.limit,
      order: pagination?.order,
      ...pagination?.filter,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
  return data;
}

async function getOfferById(offerID: string): Promise<Offer> {
  const endpoint = `/products/offer/${offerID}`;
  return (await baseClient.get(endpoint)).data;
}

async function getMobileOfferOptions() {
  const endpoint = `/products/v2/mobile-options`;
  return (await baseClient.get(endpoint)).data;
}

async function putOfferById(
  productId: string,
  offerID: string,
  data: OfferPayload
) {
  const endpoint = `/products/v2/${productId}/offers/${offerID}`;
  const result = await baseClient.put(endpoint, data);

  return result;
}

async function postOfferById(productId: string, data: OfferPayload) {
  const endpoint = `/products/v2/${productId}/offers`;
  const result = await baseClient.post(endpoint, data);

  return result;
}

async function uploadOfferImg(productId: string, file: File) {
  try {
    const formData = new FormData();
    const endpoint = `/products/v2/${productId}/offers/upload`;
    formData.append('files[]', file);

    const response = await baseClient.post(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data[0]?.key;
  } catch {
    return undefined;
  }
}

async function expireOffer(offerId: string) {
  const endpoint = `/products/v2/offers/${offerId}/expire-offer`;
  return await baseClient.patch(endpoint);
}

export const offerApi = {
  getProducts,
  getOffers,
  getPaginatedOffers,
  getOfferById,
  getMobileOfferOptions,
  putOfferById,
  postOfferById,
  getOfferProperties,
  uploadOfferImg,
  expireOffer,
};
